<template>
	<div>
		<!-- <TilteParallax image="https://cdn.hipwallpaper.com/i/7/54/QSWLXT.png"> -->
		<TilteParallax
			image="https://apps.pinturasacuario.mx/assets/store/images/customer/search.jpg"
		>
			<template v-slot:title>
				Nueva orden de compra
			</template>

			<template v-slot:menu>
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							fab
							v-on="on"
							elevation="5"
							v-bind="attrs"
							color="default"
						>
							<v-icon>
								mdi-dots-vertical
							</v-icon>
						</v-btn>
					</template>

					<v-list>
						<template>
							<v-list-item @click="salesorderImport()">
								<v-list-item-title>
									Importar desde CSV
								</v-list-item-title>
							</v-list-item>
						</template>
					</v-list>
				</v-menu>
			</template>
		</TilteParallax>

		<v-container fluid class="pt-0">
			<v-row justify="center">
				<v-col cols="12" md="10">
					<v-card
						:loading="ui.sending"
						:disabled="ui.sending"
						outlined
						:class="[
							'pt-0',
							$vuetify.breakpoint.smAndDown ? 'pa-0' : 'pa-4',
						]"
					>
						<v-card-text
							:class="[
								{ 'pa-1 pb-0': $vuetify.breakpoint.smAndDown },
							]"
						>
							<v-container fluid>
								<CreateUpdate
									:salesorder="salesorder"
									:type="'create'"
									@cancel="cancel"
									@created="created"
									v-if="salesorder != null"
								>
								</CreateUpdate>
							</v-container>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import { v } from "@/main";
import { EventBus } from "@/main";
import TilteParallax from "@/components/TilteParallax";
import CreateUpdate from "@/components/SalesOrder/CreateUpdate";

export default {
	name: "Create",

	components: { TilteParallax, CreateUpdate },

	data() {
		return {
			salesorder: {
				status_id: 1,
			},

			ui: {
				sending: false,
			},
		};
	},

	created() {
		let salesorder = JSON.parse(localStorage.getItem("salesorder"));

		if (salesorder != undefined) {
			this.salesorder = salesorder;
		} else {
			this.salesorder = {
				note: null,
				articles: [],
				user_id: null,
				shipping_method_id: null,
				user_id: this.$store.state.acount.user.id,
				customer: this.$store.state.acount.user.customer,
				customer_id: this.$store.state.acount.user.customer.id,
				discount: this.$store.state.acount.user.customer.discount,
			};
		}

		EventBus.$on("SalesOrderSending", (val) => {
			this.ui.sending = val;
		});
	},

	methods: {
		back() {
			alert("Tu orden de compra se guardará y podrás retomarlo después.");

			this.$router.go(-1);
		},

		created(salesOrder) {
			EventBus.$emit("Snackbar", {
				text: `¡Orden de compra creada correctamente #${salesOrder.id}!`,
				type: "success",
				timeout: 4000,
			});

			localStorage.removeItem("salesorder");

			this.$router.go(-1);
		},

		cancel() {
			if (confirm("¿Quíeres cancelar la orden de compra actual?")) {
				localStorage.removeItem("salesorder");

				this.$router.go(-1);
			}
		},

		salesorderImport() {
			EventBus.$emit("SalesorderImport");
		},
	},

	computed: {},
};
</script>

<style lang="css" scoped></style>
